import BidProgressBarSkeleton from 'components/BidProgressBarSkeleton';
import ProjectFooterSkeleton from 'components/ProjectFooterSkeleton';
import ProjectStatsSkeleton from 'components/ProjectStatsSkeleton';
import ProjectTitleSkeleton from 'components/ProjectTitleSkeleton';

export default function ProjectSkeleton() {
  return (
    <div className="flex flex-col max-w-screen-sm md:max-w-screen-md space-y-2">
      <ProjectTitleSkeleton />
      <ProjectStatsSkeleton />

      <div className="h-4" />

      <div className="flex w-full justify-between space-x-16 animate-pulse">
        {/* Left column */}
        <div className="flex flex-col w-[360px] md:w-[420px] p-4 border-[1px] border-semitrans bg-base-200 rounded h-36">
          <BidProgressBarSkeleton />
        </div>

        {/* Right column */}
        <div className="flex flex-col items-center w-[360px] md:w-[420px] bg-gray-300 h-96" />
      </div>

      {/* Footer */}
      <div className="h-16" />
      <ProjectFooterSkeleton />
    </div>
  );
}
